<template>
  <div class="email-subscription-container">
    <h1>Email Subscription</h1>
    
    <div v-if="verifyingToken">
      <p>Verifying token...</p>
    </div>
    
    <div v-else-if="tokenError">
      <p>{{ tokenError }}</p>
      <p>Go back to <a href="https://inboxmaster.ai" target="_blank">inboxmaster.ai</a></p>
    </div>
    
    <div v-else-if="tokenValid && !processing && !response && !error">
      <p>Confirm to unsubscribe from email notifications</p>
      <button @click="confirmUnsubscribe" class="unsubscribe-button">Unsubscribe</button>
      <p>Go back to <a href="https://inboxmaster.ai" target="_blank">inboxmaster.ai</a></p>
    </div>
    
    <div v-else-if="processing">
      <p>Processing unsubscription...</p>
    </div>
    
    <div v-else-if="response">
      <p>{{ response }}</p>
      <p>Go back to <a href="https://inboxmaster.ai" target="_blank">inboxmaster.ai</a></p>
    </div>
    
    <div v-else-if="error">
      <p>{{ error }}</p>
      <p>Go back to <a href="https://inboxmaster.ai" target="_blank">inboxmaster.ai</a></p>
    </div>
  </div>
</template>

<script>
import { subscriptionAPI } from '@/services/api';

export default {
  name: 'EmailSubscription',
  data() {
    return {
      verifyingToken: false,
      tokenValid: false,
      tokenError: null,
      processing: false,
      response: null,
      error: null,
      token: null
    };
  },
  mounted() {
    // Extract token from URL parameters
    this.token = this.$route.query.token;
    
    if (!this.token) {
      this.tokenError = 'No token provided in the URL';
      return;
    }
    
    // Verify the token when component mounts
    this.verifyToken();
  },
  methods: {
    async verifyToken() {
      if (!this.token) {
        this.tokenError = 'No token available';
        return;
      }
      
      this.verifyingToken = true;
      this.tokenError = null;
      
      try {
        await subscriptionAPI.verifyEmailSubscriptionToken(this.token);
        this.tokenValid = true;
      } catch (err) {
        console.error('Token verification error:', err);
        this.tokenError = err.response?.data?.message || err.message || 'Invalid or expired token';
      } finally {
        this.verifyingToken = false;
      }
    },
    async confirmUnsubscribe() {
      this.processing = true;
      this.error = null;
      this.response = null;
      
      try {
        const result = await subscriptionAPI.processEmailSubscription(this.token);
        this.response = result.data.message || JSON.stringify(result.data, null, 2);
      } catch (err) {
        console.error('Email subscription error:', err);
        this.error = err.response?.data?.message || err.message || 'An error occurred while processing your subscription';
      } finally {
        this.processing = false;
      }
    }
  }
};
</script>

<style scoped>
.email-subscription-container {
  padding: 20px;
  font-family: Arial, sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 100px;
}

h1 {
  margin-bottom: 30px;
}

pre {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 5px;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin-bottom: 20px;
  text-align: left;
  max-width: 600px;
}

p {
  margin-bottom: 10px;
}

a {
  color: #007bff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.unsubscribe-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin: 20px 0;
}

.unsubscribe-button:hover {
  background-color: #c82333;
}
</style>
